import { render, staticRenderFns } from "./ZammadTicket.vue?vue&type=template&id=3dd91906"
import script from "./ZammadTicket.vue?vue&type=script&lang=ts"
export * from "./ZammadTicket.vue?vue&type=script&lang=ts"
import style0 from "./ZammadTicket.vue?vue&type=style&index=0&id=3dd91906&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports